import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import {
  UXFB_CLIENT_EVENTS_CONFIG_KEY,
  UXFB_EVENT_OPEN_DEVELOPER_CARD,
  UXFB_PLATFORM_BY_DEVICE_TYPE,
} from '../../constants/uxfb';
import { useApplicationContext } from '../../utils/applicationContext';
import { sendUXSEventWhenReady } from '../../utils/uxs';

/**
 * Шлёт UXFB-событие `open_developer_card` один раз при заходе в карточку застройщика (mount).
 * Страница респонсивная, поэтому событие уходит на всех устройствах, а атрибут `platform`
 * вычисляется по типу устройства (desktop → `desktop`, phone/tablet → `mobweb`).
 *
 * `dedupeKey` обязателен: useRef не переживает ремаунт контейнера, дубль события засчитывается
 * бэкендом UXFB как лишний «заход», и кампании «на 2-й заход» выезжают уже на первом.
 */
export function useOpenDeveloperCardUxfbEvent(): void {
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();

  React.useEffect(() => {
    if (config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    sendUXSEventWhenReady(
      UXFB_EVENT_OPEN_DEVELOPER_CARD,
      { platform: UXFB_PLATFORM_BY_DEVICE_TYPE[deviceType] },
      { dedupeKey: UXFB_EVENT_OPEN_DEVELOPER_CARD },
    );
  }, [config, deviceType]);
}
